// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadMessages from "@insite/client-framework/Store/Data/Messages/Handlers/LoadMessages";
import { getMessagesDataView } from "@insite/client-framework/Store/Data/Messages/MessagesSelector";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Typography, { TypographyPresentationProps } from "@store/MobiusOverrides/Typography/Typography";
import { useIsAuthenticated } from "@store/Framework/Store/Context/ContextHooks";
import loadTECMessages from "@store/Framework/Store/Greif/Data/TECMessages/Handlers/LoadTECMessages";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const messagesParameter = {};

const mapStateToProps = (state: ApplicationState) => {
    const userMessages = getMessagesDataView(state, messagesParameter);

    return {
        userMessages,
        shouldLoadMessages: !userMessages.value && !userMessages.isLoading,
    };
};

const mapDispatchToProps = {
    loadMessages,
};

export interface MessageCountPresentationProps extends ExpandStyles<MessageCountStyles> {}

type Props = MessageCountPresentationProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

export interface MessageCountStyles {
    wrapper?: InjectableCss;
    messageCountText?: TypographyPresentationProps;
}

export const messageCountStyles: MessageCountStyles = {
    messageCountText: {
        css: css`
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 0;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: center;
            font-size: ${x => x.theme.design.typography.size.smallest};
            width: ${pxToRem(20)};
            height: ${pxToRem(20)};
            padding: ${pxToRem(1)};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            border: 1px solid ${getColor("header")};
            background-color: ${getColor("tertiary.alt")};
            color: ${getColor("tertiary.contrast")};
            border-radius: 50%;
            letter-spacing: ${pxToRem(-0.5)};
        `,
    },
};

const MessageCount = ({ shouldLoadMessages, userMessages, loadMessages, extendedStyles, overridedStyles }: Props) => {
    const styles = useExpandProps(messageCountStyles, extendedStyles, overridedStyles);
    const isAthenticated = useIsAuthenticated();

    const [messagesCount, setMessagesCount] = useState(0);

    useEffect(() => {
        if (shouldLoadMessages && isAthenticated) {
            loadMessages(messagesParameter);
        }
    }, [shouldLoadMessages]);

    useEffect(() => {
        const messagesCount = userMessages?.value?.filter(msg => !msg.isRead).length || 0;
        setMessagesCount(messagesCount);
    }, [userMessages]);

    return messagesCount ? (
        <Typography {...styles.messageCountText} aria-hidden="true">
            {messagesCount}
        </Typography>
    ) : null;
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageCount);
